import styled from 'styled-components';
import { Grid } from '@mantine/core';

const TotalHoursWrapper = styled(Grid)`
  ${props => props.applyDeletableRowStyles
    ? 'padding: 3px 1rem;'
    : 'padding: 3px 0px 3px 10px;'}
  background-color: #fff;
  margin-top: 0rem !important;
  @media screen and (max-width: 1023px) {
    padding: 0px 10px; 
  }

  > div > p {
    margin: .5rem -0.5rem .25rem -0.5rem;
    padding-right: 0.5rem;
    padding-left: 0.5rem;

    @media only screen and (min-width: 1024px) {
      margin: .5rem 4.5rem .5rem -0.5rem;
      text-align: right;
    }
  }
`;

const TotalsCol = styled(Grid.Col)`
  p {
    text-align: center;

    @media only screen and (min-width: 1024px) {
      margin-top: .5rem;
      margin-bottom: .5rem;
    }
  }
`;

const TotalsHR = styled.hr`
  margin-left: 55%;
  margin-right: -0.5rem;
  margin-top: 0rem;
  margin-bottom: 0rem;
  border-top: 1.5px solid #e6e6e6;
  height: 1.5px;

  @media only screen and (max-width: 1199px) {
    margin-left: 43%;
  }

  @media only screen and (max-width: 1023px) {
    display: none;
  }
`;

const TotalHoursSticky = styled.div`
  > div > div:nth-child(2) {
    width: 96%;
    @media screen and (min-width: 545px) {
      width: 91%;
    }

    @media screen and (min-width: 770px) {    
      width:694px;
    }
    
    @media screen and (min-width: 1024px) {      
      width: 935px;
    }
    @media screen and (min-width: 1200px) {
      width: 1170px;
    }
  }
`;

export {
  TotalHoursWrapper,
  TotalsCol,
  TotalsHR,
  TotalHoursSticky
};